import React from "react";
import { PaymentWrapperView } from "./enum";
import usePaymentWrapperService from "./service";
import { PaymentComponentWrapperArgsType } from "./type";
import { OfflinePaymentRequested } from "./components/offlinePayment/components";
import { InvoicePayment, OfflinePayment, PaymentWrapperHeader } from "./components";
import { Suspense } from "react";
import FullPageLoaderWithPortal from "../loader";
import ErrorBoundary from "../errorBoundary";
import { ChunkReloadCustom } from "../chunkReload";
const PaymentComponent = React.lazy(() => import("../payment"));

function PaymentComponentWrapper(props: PaymentComponentWrapperArgsType) {
  const service = usePaymentWrapperService(props);

  return (
    <div className="paymentWrapper">
      {props.customHeader ? (
        props.customHeader
      ) : (
        <PaymentWrapperHeader
          state={service.state}
          dispatch={service.dispatch}
          invoicePaymentRequestId={props.invoicePaymentRequestId}
          toggleInvoicePayment={service.toggleInvoicePayment}
          toggleOfflinePayment={service.toggleOfflinePayment}
          invoicePaymentConfig={props.invoicePaymentConfig}
          invoicePaymentEnabled={service.paymentMethodsEnabled.invoicePaymentEnabled}
          offlinePaymentConfig={props.offlinePaymentConfig}
          offlinePaymentEnabled={service.paymentMethodsEnabled.offlinePaymentEnabled}
          registrationParticipantId={props.registrationParticipantId}
          resendInvoicePaymentReminderSuccessHandler={props.resendInvoicePaymentReminderSuccessHandler}
          shouldShowPaymentModeOptions={props.shouldShowPaymentModeOptions}
        />
      )}
      {service.state.paymentWrapperView === PaymentWrapperView.REQUEST_PAYMENT ? (
        <InvoicePayment
          amount={props.amount}
          purchaseOrderId={props.purchaseOrderId}
          invoicePaymentConfig={props.invoicePaymentConfig}
          registrationParticipantId={props.registrationParticipantId}
          invoicePaymentRequestSuccessHandler={props.invoicePayerPaymentRequestSuccessHandler}
        />
      ) : service.state.paymentWrapperView === PaymentWrapperView.OFFLINE_PAYMENT ? (
        <OfflinePayment
          amount={props.amount}
          errorHandler={props.errorHandler}
          successHandler={props.successHandler}
          purchaseOrderId={props.purchaseOrderId}
          offlinePaymentConfig={props.offlinePaymentConfig}
          registrationParticipantId={props.registrationParticipantId}
          backToOfflineRequestedClickHandler={
            props.offlinePaymentConfig?.offlinePaymentRequested ? service.backToOfflineRequestedClickHandler : undefined
          }
          offlineTransactionUpdateSuccessHandler={props.offlineTransactionUpdateSuccessHandler}
        />
      ) : service.state.paymentWrapperView === PaymentWrapperView.OFFLINE_PAYMENT_REQUESTED ? (
        <OfflinePaymentRequested
          state={service.state}
          dispatch={service.dispatch}
          errorHandler={props.errorHandler}
          purchaseOrderId={props.purchaseOrderId}
          registrationParticipantId={props.registrationParticipantId}
          registrationParticipantUiVersion={props.registrationParticipantUiVersion}
          offlineTransactionCancelSuccessHandler={props.offlineTransactionCancelSuccessHandler}
        />
      ) : (
        service.state.paymentWrapperView === PaymentWrapperView.PAY_BY_SELF && (
          <ErrorBoundary
            errorComponent={
              <div style={{ height: 250 }}>
                <div style={{ marginTop: 20 }}>
                  <ChunkReloadCustom />
                </div>
              </div>
            }>
            <Suspense fallback={<FullPageLoaderWithPortal isLoading={true} />}>
              <PaymentComponent
                key={service.uniqueRandomKey}
                setPaymentNonce={service.setPaymentNonce}
                amountObj={props.amount}
                registrationParticipantId={props.registrationParticipantId}
                errorHandler={props.errorHandler}
                showCardIcons={props.showCardIcons}
                purchaseOrderId={props.purchaseOrderId}
                onAmountMismatch={props.onAmountMismatch}
                logPurchaseError={props.logPurchaseError}
                displayErrorMessage={props.displayErrorMessage}
                invoicePayerId={props.isInvoicePayer ? props.invoicePayerId : undefined}
                onPurchaseOrderVerificationFailure={props.onPurchaseOrderVerificationFailure}
                stripeReturnUrl={props.stripeReturnUrl}
                onTokenInitialised={service.tokenInitialisedHandler}
                backToOfflineRequestedClickHandler={
                  props.offlinePaymentConfig?.offlinePaymentRequested
                    ? service.backToOfflineRequestedClickHandler
                    : undefined
                }
                isPaymentSyncFailedForStripe={service.state.isPaymentSyncFailed}
                shouldAutoProcessStripePaymentFailure={props.shouldAutoProcessStripePaymentFailure}
              />
            </Suspense>
          </ErrorBoundary>
        )
      )}
    </div>
  );
}

export default PaymentComponentWrapper;
